export default __webpack_public_path__ + "icon-matriz-326f89576ae2364daa275c1ee34f930b.svg";